// Utility function to await grecaptcha.ready
export async function waitForGRecaptchaReady(timeoutMs = 5000, intervalTimeMs = 200) {
	return new Promise((resolve, reject) => {
		let waited = 0;
		if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
			grecaptcha.ready(resolve);
		} else {
			const interval = setInterval(() => {
				waited += intervalTimeMs;
				if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
					clearInterval(interval);
					grecaptcha.ready(resolve);
				} else if (waited >= timeoutMs) {
					clearInterval(interval);
					reject(new Error('reCAPTCHA not available after 5 seconds'));
				}
			}, intervalTimeMs);
		}
	});
}

export async function resetGRecaptchaToken($formElement, gRecaptchaQuerySelector = '.g-recaptcha') {
	await waitForGRecaptchaReady();
	const $gRecaptcha = $formElement.querySelector(gRecaptchaQuerySelector);
	if (!$gRecaptcha) {
		return;
	}
	const token = await grecaptcha.execute($gRecaptcha.dataset.sitekey, { action: "form" });
	$gRecaptcha.value = token;
}
